import { Dialog, DialogContent } from '@repo/videa-components/src/ui/dialog';

import { PatientEducationContent } from './PatientEducationContent';

type PatientEducationDialogProps = {
  imageId?: string;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export const PatientEducationDialog = ({
  imageId,
  isOpen,
  setIsOpen,
}: PatientEducationDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent
        data-testid="patient-education-dialog"
        className="vai-bg-background-dark vai-text-foreground-dark vai-max-w-[1024px] vai-max-h-[90vh] vai-z-[200] vai-overflow-y-auto"
      >
        <PatientEducationContent imageId={imageId} />
      </DialogContent>
    </Dialog>
  );
};
